import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from './Navbar';
import Footer from './Footer';

function NotFound() {
  return (
    <div className="flex flex-col min-h-screen">
      <Navbar />
      <div className="flex-1 flex flex-col items-center justify-center px-6 py-32 text-center">
        <h1 className="text-9xl font-extrabold text-red-600 leading-none">404</h1>
        <h2 className="text-3xl font-bold text-gray-800 mt-4 mb-3">Stránka nenájdená</h2>
        <p className="text-gray-500 max-w-md mb-10">
          Ľutujeme, stránka ktorú hľadáte neexistuje alebo bola presunutá.
        </p>
        <Link
          to="/"
          className="bg-red-600 hover:bg-red-700 text-white px-8 py-4 rounded font-semibold text-lg transition-colors duration-200"
        >
          Späť na hlavnú stránku
        </Link>
      </div>
      <Footer />
    </div>
  );
}

export default NotFound;
